'use strict';

const base = require('./base');
const focusHelper = require('base/components/focus');

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    const quickViewModal = $('#quickViewModal');
    if (quickViewModal.length !== 0) {
        quickViewModal.remove();
    }
    let htmlString = `<!-- Modal -->
        <div class="modal fade" id="quickViewModal" role="dialog">
        <span class="enter-message sr-only" ></span>
        <div class="modal-dialog quick-view-dialog">
        <!-- Modal content-->
        <div class="modal-content">
        <div class="modal-header">
            <a class="full-pdp-link" href=""></a>
            <button type="button" class="close pull-right" data-dismiss="modal">
                <i class="icon icon-close"></i>
            </button>
        </div>
        <div class="modal-body"></div>
        </div>
        </div>
        </div>`;
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    let $html = $('<div>').append($.parseHTML(html));

    let body = $html.find('.product-quickview');

    return { body: body };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    const quickViewModal = $('#quickViewModal');
    let quickViewModalBody = quickViewModal.find('.modal-body');

    quickViewModalBody.spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            let parsedHtml = parseHtml(data.renderedTemplate);

            quickViewModalBody.empty().html(parsedHtml.body);
            quickViewModal.find('.full-pdp-link').text(data.quickViewFullDetailMsg).attr('href', data.productUrl);
            quickViewModal.find('.size-chart').attr('href', data.productUrl);
            quickViewModal.find('.enter-message').text(data.enterDialogMessage);
            quickViewModal.modal('show');
            quickViewModal.addClass('quickview-wrapper');
            $('body').trigger('quickview:ready');
            if ($('#quickViewModal .pdp-image-carousel .pdp-image-item').length > 1) {
                // Custom Richemont QuickBuy Modal
                // Check if custom pagination is configured
                let $customPaginationSelector = quickViewModal.find('.quickview-image-custom-pagination');
                let quickViewSliderNav = quickViewModal.find('.slider-nav');
                let quickViewSlickSlider = quickViewModal.find('.slick-slider');
                if ($customPaginationSelector.length) {
                    // Update pagination on init
                    quickViewSliderNav.on('init', function (event, slick) {
                        let currentSlide = slick.currentSlide + 1;
                        let totalSlides = slick.slideCount;
                        $customPaginationSelector.text(`${currentSlide} / ${totalSlides}`);
                    });

                    // Update pagination on afterChange
                    quickViewSliderNav.on('afterChange', function (event, slick, currentSlide) {
                        let current = currentSlide + 1;
                        let total = slick.slideCount;
                        $customPaginationSelector.text(`${current} / ${total}`);
                    });
                }

                // Initialize Slick
                let quickViewMTBModal = quickViewModal.find('.product-quickview').data('brand');
                if (quickViewMTBModal === 'mtb') {
                    quickViewSlickSlider.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        infinite: false,
                        swipeToSlide: true,
                        responsive: [
                            {
                                breakpoint: 992,
                                settings: {
                                    dots: true,
                                },
                            },
                        ],
                        asNavFor: '#quickViewModal .slider-nav',
                    });
                    quickViewSliderNav.slick({
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        asNavFor: '#quickViewModal .slick-slider',
                        dots: false,
                        infinite: false,
                        vertical: true,
                        verticalSwiping: true,
                        swipeToSlide: true,
                        focusOnSelect: true,
                        prevArrow: '<div class="slick-prev"><i class="icon icon-prev icon-size-m" aria-hidden="true"></i></div>',
                        nextArrow: '<div class="slick-next"><i class="icon icon-next icon-size-m" aria-hidden="true"></i></div>',
                    });
                }
            }

            var $form = $('#quickViewModal .add-to-wishlist-form');
            var productId = $form.find('input[name="pid"]').val();
            const wishlistItem = window.allWishlistItems ? window.allWishlistItems.find((item) => item.pid === productId) : null;
            if (wishlistItem) {
                $form.find('.wishlist-wrapper').addClass('added-to-wishlist');
                $form.attr('action', $form.attr('action').replace('Wishlist-AddProduct', 'Wishlist-RemoveProduct'));
            } else {
                $form.find('.wishlist-wrapper').removeClass('added-to-wishlist');
            }

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

module.exports = {
    showQuickview: function () {
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            let selectedValueUrl = $(this).closest('a.quickview').attr('href');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();

            fillModalElement(selectedValueUrl);
        });
    },
    focusQuickview: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal .close').focus();
        });
    },
    trapQuickviewFocus: function () {
        $('body').on('keydown', '#quickViewModal', function (e) {
            let focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    availability: base.availability,
    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.modal-content').spinner().start();
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function (e, response) {
            // Custom Richemont QuickBuy Modal
            let modalContent = $('.product-quickview');
            let brand = modalContent.data('brand');
            if (brand !== 'mtb') {
                $('#quickViewModal').modal('hide');
            } else {
                const addToCartMessage = $('.added-to-cart-message');
                addToCartMessage.show();
                addToCartMessage.closest('.detail-panel').find('button.add-to-cart').html(response.addedProductToaster.details.addOneMoreLabel);
            }
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelect', function () {
            $('.modal.show .modal-content').spinner().start();

            let modalContent = $('.product-quickview');
            let brand = modalContent.data('brand');

            if (brand === 'chl') {
                modalContent.find('.select-size-message').addClass('d-none');
            }
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            let modalShowState = $('.modal.show');
            if (modalShowState.find('.modal.show .product-quickview > .bundle-items').length) {
                modalShowState.find(response.container).data('pid', response.data.product.id);
                modalShowState.find(response.container).find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                modalShowState.find('.product-quickview').data('pid', response.data.product.id);
                modalShowState.find('.full-pdp-link').attr('href', response.data.product.selectedProductUrl);
            }

            // Custom Richemont QuickBuy Modal
            let modalContent = $('.product-quickview');
            let brand = modalContent.data('brand');
            if (brand === 'mtb') {
                const addToCartMessage = $('.added-to-cart-message');
                addToCartMessage.hide();
                addToCartMessage.closest('.detail-panel').find('button.add-to-cart').html(response.data.resources.add_to_bag);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            const available = response.product.available;
            const notifyBtnText = response.product.notifyBtnText;
            const readyToOrder = response.product.readyToOrder;
            let disableAddToCart = !available;
            $('.add-to-cart-slider', response.container).toggleClass('d-none', readyToOrder);
            if ($('.add-to-cart-slider').length) {
                disableAddToCart = disableAddToCart || !readyToOrder;
            }
            if (!disableAddToCart && $('.charms-slider-opener').length) {
                const isCharmSelected = $('.attribute-charm').first().hasClass('selected');
                if (!isCharmSelected) {
                    disableAddToCart = true;
                }
                $('.charms-slider-opener').toggleClass('d-none', isCharmSelected);
            }
            $('button.add-to-cart', response.container).toggleClass('d-none', disableAddToCart).attr('data-pid', response.product.id);

            $('.notify-me-link', response.container).toggleClass('d-none', available);
            if (notifyBtnText) {
                $('.notify-me-link, .notify-me-btn button', response.container).text(notifyBtnText);
            }

            // update global add to cart (single products, bundles)
            let dialog = $(response.$productContainer).closest('.quick-view-dialog');

            $('.add-to-cart-global', dialog).attr('disabled', !$('.global-availability', dialog).data('ready-to-order') || !$('.global-availability', dialog).data('available'));
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);

            let dialog = $(response.$productContainer).closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                let allAvailable = $('.product-availability', dialog)
                    .toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                let allReady = $('.product-availability', dialog)
                    .toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability', dialog).data('ready-to-order', allReady).data('available', allAvailable);

                $('.global-availability .availability-msg', dialog)
                    .empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    },
    showSelectMessage: function () {
        // Custom Richemont QuickBuy Modal
        $('body').on('click', '.quick-view-dialog .add-to-cart-slider', function () {
            let modalContent = $('.product-quickview');
            let brand = modalContent.data('brand');

            if (brand === 'chl' && $('.swatch').length) {
                modalContent.find('.attribute').each(function () {
                    if ($(this).find('.options-select:checked').length === 0) {
                        modalContent.find('.select-size-message').removeClass('d-none');
                    }
                });
            }
        });
    },
};
